import { isTauri } from "@tauri-apps/api/core";

export const isApp = isTauri();
